import {OfferItem} from "@/components/model/offer-item";
import {http} from "@/components/http/http.service";

export class ItemService {
    loadById(id: number): Promise<OfferItem> {
        return http.get<OfferItem>(`/api/offer-items/${id}`);
    }
}

export const item = new ItemService();
